<template>
  <section v-if="visibleItems.length" class="admin-nav-group">
    <button
      v-if="!collapsed"
      type="button"
      class="admin-nav-group__toggle admin-button--ghost"
      :aria-expanded="open"
      :aria-controls="`admin-nav-${group.key}`"
      @click="$emit('toggle', group.key)"
    >
      <i class="fa" :class="group.icon" aria-hidden="true"></i>
      <span>{{ group.label }}</span>
      <i class="fa fa-chevron-down admin-nav-group__chevron" :class="{ 'admin-nav-group__chevron--open': open }" aria-hidden="true"></i>
    </button>
    <div
      v-if="collapsed || open"
      :id="`admin-nav-${group.key}`"
      class="admin-nav-group__items"
      :class="{ 'admin-nav-group__items--collapsed': collapsed }"
    >
      <AdminNavItem
        v-for="item in visibleItems"
        :key="item.key"
        :item="item"
        :collapsed="collapsed"
        @select="$emit('select')"
      />
    </div>
  </section>
</template>

<script>
import { computed } from "vue";
import { useRouter } from "vue-router";
import AdminNavItem from "./AdminNavItem.vue";
import { hasAdminAccess, useAdminSession } from "@/admin/adminSession";

export default {
  name: "AdminNavGroup",
  components: { AdminNavItem },
  props: {
    group: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggle", "select"],
  setup(props) {
    const router = useRouter();
    const { stats } = useAdminSession();

    const visibleItems = computed(() =>
      props.group.items.filter((item) => {
        const route = router.getRoutes().find((entry) => entry.name === item.routeName);
        return hasAdminAccess(route?.meta?.adminAccess, stats.value?.permissions || {});
      })
    );

    return { visibleItems };
  },
};
</script>
